module.exports = __webpack_public_path__ + "static/img/Head_bg2.6682d847.png";